<template>
  <div>
    <v-container grid-list-sm class="py-2 px-0"> <!-- text-xs-center -->
      <v-layout row wrap>
        <v-flex></v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #4E342E;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <span class="caption" style="color: #4E342E;">A12</span>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; Regular</p>
          <!--<div class="layout-seat-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #4E342E; background: #4E342E;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<span class="caption" style="color: white;">A12</span>-->
            <!--</p>-->
          <!--</div><p style="margin-top: 2px;"> &nbsp; #4E342E</p>-->
        </v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #2979FF;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <v-icon color="blue accent-3">accessible</v-icon>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; Wheelchair</p>
          <!--<div class="layout-seat-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #2979FF; background: #2979FF;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<v-icon color="white">accessible</v-icon>-->
            <!--</p>-->
          <!--</div><p style="margin-top: 2px;"> &nbsp; #2979FF</p>-->
        </v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #FF6D00;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <v-icon color="orange accent-4">star</v-icon>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; VIP</p>
          <!--<div class="layout-seat-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #FF6D00; background: #FF6D00;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<v-icon color="white">star</v-icon>-->
            <!--</p>-->
          <!--</div><p style="margin-top: 2px;"> &nbsp; #FF6D00</p>-->
        </v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #B388FF;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <v-icon color="deep-purple accent-1">airline_seat_recline_extra</v-icon>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; Recliner</p>
          <!--<div class="layout-seat-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #B388FF; background: #B388FF;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<v-icon color="white">airline_seat_recline_extra</v-icon>-->
            <!--</p>-->
          <!--</div><p style="margin-top: 2px;"> &nbsp; #B388FF</p>-->
        </v-flex>
        <v-flex>
          <div class="layout-left-sofa-legend"
               style="width: 36px; border: solid 2px #9E9D24; border-right-width: 1px;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <span class="caption" style="color: #9E9D24;">G15</span>
            </p>
          </div> <!-- width: 44px -->
          <div class="layout-right-sofa-legend"
               style="width: 36px; border: solid 2px #9E9D24; border-left-width: 1px;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <span class="caption" style="color: #9E9D24;">G16</span>
            </p>
          </div>
          <p style="margin-top: 2px;"> &nbsp; Sofa</p>
          <!--<div class="layout-left-sofa-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #9E9D24; border-right-width: 1px; background: #9E9D24;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<span class="caption" style="color: white;">G15</span>-->
            <!--</p>-->
          <!--</div> &lt;!&ndash; width: 44px &ndash;&gt;-->
          <!--<div class="layout-right-sofa-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #9E9D24; border-left-width: 1px; background: #9E9D24;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<span class="caption" style="color: white;">G16</span>-->
            <!--</p>-->
          <!--</div>-->
          <!--<p style="margin-top: 2px;"> &nbsp; #9E9D24</p>-->
        </v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #FDD835;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <span class="caption" style="color: #FDD835;">G15</span>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; Companion</p>
          <!--<div class="layout-seat-legend elevation-6"-->
               <!--style="width: 36px; border: solid 2px #FDD835; background: #FDD835;"-->
          <!--&gt;-->
            <!--<p class="layout-seat-name subheading text-xs-center"-->
               <!--slot="activator"-->
               <!--style="margin-top: -2px;"-->
            <!--&gt;-->
              <!--<span class="caption" style="color: white;">G15</span>-->
            <!--</p>-->
          <!--</div><p style="margin-top: 2px;"> &nbsp; #FDD835</p>-->
        </v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #FFCDD2;"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <v-icon color="red lighten-4">build</v-icon>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; Broken</p>
        </v-flex>
        <v-flex>
          <div class="layout-seat-legend"
               style="width: 36px; border: solid 2px #E0E0E0; background: #E0E0E0"
          >
            <p class="layout-seat-name subheading text-xs-center"
               slot="activator"
               style="margin-top: -2px;"
            >
              <span class="caption" style="color: #9E9E9E;">A12</span>
            </p>
          </div><p style="margin-top: 2px;"> &nbsp; Sold</p>
        </v-flex>
        <v-flex></v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
  export default {
    name: "booking-legend"
  }
</script>

<style scoped>
  .layout-seat-legend {
    border-bottom-right-radius: 10px;
    border-bottom-left-radius: 10px;
    height: 26px;
    float: left;
  }
  .layout-left-sofa-legend {
    border-bottom-left-radius: 10px;
    height: 26px;
    float: left;
  }
  .layout-right-sofa-legend {
    border-bottom-right-radius: 10px;
    height: 26px;
    float: left;
  }
  .caption {
    font-weight: bold
  }
</style>



// WEBPACK FOOTER //
// src/components/booking/Legend.vue